import React from 'react';
import { CalendarMode } from '../types';
import Stack from '../../Stack';
import IconButton from '../../IconButton';

export type CalendarModeToggleOwnProps = {
    calendarMode: CalendarMode;
    setCalendarMode: (mode: CalendarMode) => void;
};

export type CalendarModeToggleProps = CalendarModeToggleOwnProps;

const CalendarModeToggle: React.FC<CalendarModeToggleProps> = (props) => {
    return (
        <Stack horizontal>
            <IconButton
                variant="large-transparent"
                icon="Calendar"
                onPress={() => props.setCalendarMode('calendar')}
                isDisabled={props.calendarMode === 'calendar'}
                testID="calendar-mode-toggle-calendar"
            />
            <IconButton
                variant="large-transparent"
                icon="List"
                onPress={() => props.setCalendarMode('list')}
                isDisabled={props.calendarMode === 'list'}
                testID="calendar-mode-toggle-list"
            />
        </Stack>
    );
};

export default React.memo(CalendarModeToggle);
